module.exports = __webpack_public_path__ + "img/bb_g3_wrinkles-body.ed21103d.svg";